
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as g2gns1inSIekeqhRy5FvvxiVAds_45qd2eY_96jWNISBGYMeta } from "/codebuild/output/src791933123/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexzomgwD5E4U5OUf_45l_GpPGVhWoRaV31aIiHSv_45uki2GQMeta } from "/codebuild/output/src791933123/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchYVqVNzqf8vJ_45aRM5av_4568c7H1zs_4573ups_45l0mpD5f2sMeta } from "/codebuild/output/src791933123/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexj4BtO6jUL8HwMz4WXXYZXBEdkEtxa1aYDj9_aCo1qIAMeta } from "/codebuild/output/src791933123/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93Z4dEK1YqoSPTdfgvwfcCKiDOu7It_455E9FRAzXTL_45OyEMeta } from "/codebuild/output/src791933123/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexZ5sU7OJLW1_45kxzYYKBSS_456F7zxfSpyOf3_45MncbFKSacMeta } from "/codebuild/output/src791933123/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_937yUHVBLOymgE_50_9OhJFosbBmvWbslZUeBqyJcTkiUMeta } from "/codebuild/output/src791933123/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexB7LwETaYgVKnYTjSNzLXOEsOxSvhraIb_45HBbboo46pkMeta } from "/codebuild/output/src791933123/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93p7IkSgnAaweGpj0CFF_lG7nFDIXlNmu_45o0o9VeZJo68Meta } from "/codebuild/output/src791933123/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexhvKzu2H1XkUu7bwmxJ92xt20FyDfsS_45RlDW_45kcY5ZtYMeta } from "/codebuild/output/src791933123/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as index2x1yQkDVYb_1rL0idXcAnaRGLmfc8F6FkTI6hk82KWIMeta } from "/codebuild/output/src791933123/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src791933123/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src791933123/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src791933123/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src791933123/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src791933123/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexZ5sU7OJLW1_45kxzYYKBSS_456F7zxfSpyOf3_45MncbFKSacMeta || {},
    component: () => import("/codebuild/output/src791933123/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src791933123/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexB7LwETaYgVKnYTjSNzLXOEsOxSvhraIb_45HBbboo46pkMeta || {},
    component: () => import("/codebuild/output/src791933123/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src791933123/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexhvKzu2H1XkUu7bwmxJ92xt20FyDfsS_45RlDW_45kcY5ZtYMeta || {},
    component: () => import("/codebuild/output/src791933123/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: index2x1yQkDVYb_1rL0idXcAnaRGLmfc8F6FkTI6hk82KWIMeta || {},
    component: () => import("/codebuild/output/src791933123/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]